import { render, staticRenderFns } from "./BreadcrumbPhases.vue?vue&type=template&id=f8d37098&scoped=true&"
import script from "./BreadcrumbPhases.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbPhases.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbPhases.vue?vue&type=style&index=0&id=f8d37098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d37098",
  null
  
)

export default component.exports